var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoFacebook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1852 38.8148 0 25 0C11.1852 0 0 11.1852 0 25C0 37.4815 9.14815 47.8148 21.1111 49.7037V32.2222H14.7407V25H21.1111V19.4815C21.1111 13.2222 24.8148 9.77778 30.5185 9.77778C33.2593 9.77778 36.1111 10.2593 36.1111 10.2593V16.4074H32.963C29.8519 16.4074 28.8889 18.3333 28.8889 20.2963V25H35.8148L34.7037 32.2222H28.8889V49.7037C40.8518 47.8148 50 37.4815 50 25Z",
    fill: "#4676ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7407 32.223L35.8518 25.0008H28.8889V20.2971C28.8889 18.3341 29.8518 16.4082 32.963 16.4082H36.1111V10.26C36.1111 10.26 33.2593 9.77856 30.5185 9.77856C24.8148 9.77856 21.1111 13.223 21.1111 19.4823V25.0008H14.7407V32.223H21.1111V49.7045C22.3704 49.8897 23.7037 50.0008 25 50.0008C26.3333 50.0008 27.6296 49.8897 28.8889 49.7045V32.223H34.7407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFacebook2);
export default __webpack_public_path__ + "static/media/IconoFacebook2.aa7145d905fc30c1f684f637f026351d.svg";
export { ForwardRef as ReactComponent };